module.exports = __webpack_public_path__ + "img/2.39b50b12.gif";